import { AxiosResponse, AxiosStatic } from "axios";
import { IPatchPayload } from "../../components/course-author/helpers/patches";

export interface IScormPackagesApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export interface IScormPackagesApi {
  getEditableByRelativeTo: (accountId: string, organizationId: string) => Promise<AxiosResponse<string[]>>;
  patchScormPackage: (accountId: string, scormPackageId: string, patch: IPatchPayload) => Promise<AxiosResponse>;
}

export default class ScormPackagesApi implements IScormPackagesApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: IScormPackagesApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public getEditableByRelativeTo = (accountId: string, organizationId: string) => {
    return this.axios.get(
      `${this.apiRoot}/collections/scormPackages/visibleBy/${accountId}/targetingOrg/${organizationId}`,
      {
        params: { activeUser: accountId },
      }
    );
  };

  public patchScormPackage = (activeUser: string, scormPackageId: string, patch: IPatchPayload) =>
    this.axios.post(`${this.apiRoot}/scormPackages/${scormPackageId}/_patches`, patch, { params: { activeUser } });
}
